import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import {} from "../../store/actions";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

import logoLightSvg from "../../assets/images/logo.svg";
import dashboard from "../../assets/images/icon/dashboard.svg";
import position from "../../assets/images/icon/positions-ico.svg";
import eligibleapp from "../../assets/images/icon/eligible-ico.svg";
import scheduledint from "../../assets/images/icon/scheduled-ico.svg";
import allapp from "../../assets/images/icon/all-app-ico.svg";
import mcqmanager from "../../assets/images/icon/mcq-ico.svg";
import partialform from "../../assets/images/icon/partial-ico.svg";
import bulkupload from "../../assets/images/icon/bulk-upload-ico.svg";
import locationma from "../../assets/images/icon/location-ico.svg";
import allreports from "../../assets/images/icon/all-report-ico.svg";
import refrelmanagemt from "../../assets/images/icon/referral-ico.svg";
import alluser from "../../assets/images/icon/all-users.svg";
import settings from "../../assets/images/icon/setting-ico.svg";
import frencise from "../../assets/images/icon/frencise.svg";
import settings1 from "../../assets/images/icon/settings-icon1.svg";
import cookies_cons from "../../assets/images/icon/cookies-consent-list.svg";
import pii_cons from "../../assets/images/icon/pii-constent.svg";
import account_delete from "../../assets/images/icon/account-delete.svg";
import sentiment from "../../assets/images/emoticon-outline.svg";
import sentiment_icon from "../../assets/images/icon/video_icon2.svg";

import dept_icon from "../../assets/images/icon/department.svg";
import mcq_icon from "../../assets/images/icon/mcq-icon.svg";
import particial_iocn from "../../assets/images/icon/particial.svg";
import all_reports from "../../assets/images/icon/all-reports.svg";
import feedback_icon from "../../assets/images/icon/feedback-icon.svg";
import resource_pool from "../../assets/images/icon/resource-pool.svg";
import bulk_import from "../../assets/images/icon/bulk-import.svg";
import skill_set from "../../assets/images/icon/skill-set.svg";
import templatelist from "../../assets/images/icon/templatelist1.svg";
import neuro_bot from "../../assets/images/icon/bot.svg";

import logoLightSvg2 from "../../assets/images/pizza-hut/pizza-hut-logo.svg";
import logoLightSvg3 from "../../assets/images/pizza-hut/pizza-hut-cap.png";

import { getUserInfo } from "helpers/authHelper";
import { getRolewiseAccess } from "helpers/backend_helper";
import { GetCompanyData } from "services/CompanyService";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeDropdownId: null,
      activePage: "",
      roleWiseAccess: [],
      roleInfo: {},
      isSubMenuActive: false,
      data: "",
    };
  }

  toggleDropdown = dropdownId => {
    this.setState(prevState => ({
      activeDropdownId:
        prevState.activeDropdownId === dropdownId ? null : dropdownId,
    }));
  };

  fetchCompany = () => {
    GetCompanyData()
      .then(res => {
        let companyData = res?.data?.data || {};
        this.setState({ data: companyData });
      })
      .catch(err => {});
  };

  async componentDidMount() {
    this.fetchCompany();
    let authUser = JSON.parse(localStorage.getItem("authUser"));
    const userInfo = authUser?.user;

    let roleId = userInfo?.role_id;
    const user_id = userInfo?.id;

    let roleWiseData = localStorage.getItem("roleWiseAccess")
      ? JSON.parse(localStorage.getItem("roleWiseAccess"))
      : "";

    await getRolewiseAccess(roleId)
      .then(res => {
        if (!this.objectPropertyMatches(roleWiseData, res?.dataList)) {
          this.setState({
            roleWiseAccess: res?.dataList,
            roleInfo: res?.roleInfo,
          });
          localStorage.setItem("roleWiseAccess", JSON.stringify(res?.dataList));
        }
      })
      .catch(err => {
        console.log("route-error", err?.message);
      });
  }

  objectPropertyMatches = (obj, source) =>
    Object.keys(source).every(
      key => obj.hasOwnProperty(key) && obj[key] === source[key]
    );

  checkPermissionStatus = (link, action = "view") => {
    const roleWiseData = localStorage.getItem("roleWiseAccess")
      ? JSON.parse(localStorage.getItem("roleWiseAccess"))
      : [];
    // console.log(roleWiseData, "roleWiseData");
    if (!roleWiseData.length) return false;

    // normalize route (remove leading slash)
    const normalizedLink = link.replace(/^\/+/, "");

    const permission = roleWiseData.find(el => el.menu_link === normalizedLink);

    return Boolean(permission?.actions?.[action]);
  };

  toggleSubMenu = () => {
    this.setState(prevState => ({
      isSubMenuActive: !prevState.isSubMenuActive,
    }));
  };

  // Helper function to check if the current page is active
  isActive = link => {
    return this.props.location.pathname === link ? "mm-active" : "";
  };

  isAnySubMenuActive = paths => {
    if (!Array.isArray(paths)) {
      console.warn("Provided paths is not an array:", paths);
      return false; // Return false if paths is not an array
    }

    return paths.some(path => this.isActive(path));
  };

  render() {
    const { t } = this.props;
    const { activeDropdownId } = this.state;

    const userInfo = getUserInfo();
    const { isSubMenuActive } = this.state;
    return (
      <React.Fragment>
        <div className="vertical-menu">
          <div className="navbar-brand-box">
            <span className="logo logo-light">
              <span className="logo-lg text-center neuro-logo">
                <img
                  src={this.state.data?.company_logo}
                  height="30"
                  width="180"
                  alt="Company Logo"
                />
              </span>

              <span className="logo-lg text-center pizza-logo">
                <img
                  src={this.state.data?.company_logo}
                  height="30"
                  width="180"
                  alt="Company Logo"
                />
              </span>

              <span className="logo-lg text-center pizza-logo2">
                <img
                  src={this.state.data?.company_logo}
                  height="30"
                  width="180"
                  alt="Company Logo"
                />
              </span>
            </span>
          </div>

          <div data-simplebar className="h-100">
            <div id="sidebar-menu" className="cus-scr">
              <ul className="metismenu list-unstyled new-list" id="side-menu">
                {this.checkPermissionStatus("/dashboard") && (
                  <li className={this.isActive("/dashboard")}>
                    <Link to="/dashboard">
                      <img src={dashboard} alt=" Dashboard Icon" />
                      <span>{t(`Dashboard.Dashboard`)}</span>
                    </Link>
                  </li>
                )}

                {this.checkPermissionStatus("/dashboard") && (
                  <li className="text-content">
                    <Link to="#">
                      <span>{t(`Sidebar.MANAGE`)}</span>
                    </Link>
                  </li>
                )}
                {this.checkPermissionStatus("organization") && (
                  <li className={this.isActive("/organization")}>
                    <Link to="/organization">
                      <img src={allapp} alt="Organization Icon" />
                      <span>{t(`Sidebar.Organization`)}</span>
                    </Link>
                  </li>
                )}
                {this.checkPermissionStatus("/department-list") && (
                  <li className={this.isActive("/department-list")}>
                    <Link to="/department-list">
                      <img src={dept_icon} alt="Department Icon" />
                      <span>{t(`Sidebar.Department`)}</span>
                    </Link>
                  </li>
                )}
                   {this.checkPermissionStatus("/enquiries") && (
                  <li className={this.isActive("/enquiries")}>
                    <Link to="/enquiries">
                      <img src={dept_icon} alt="Department Icon" />
                      <span>{t(`Sidebar.enquiries`)}</span>
                    </Link>
                  </li>
                )}
                {this.checkPermissionStatus("/job-list") && (
                  <li className={this.isActive("/job-list")}>
                    <Link to="/job-list">
                      <img src={position} alt="Positions Icon" />
                      <span>{t(`Sidebar.Positions`)}</span>
                    </Link>
                  </li>
                )}

                {[
                  "/all-applications",
                  "/pending-list",
                  "/screening-list",
                  "/scheduled-list",
                  "/selected-list",
                  "/onboarded-list",
                  "/onhold-list",
                  "/rejected-list",
                  "/preassessment-list",
                ].some(link => this.checkPermissionStatus(link)) && (
                  <li
                    className={`main-list-item ${
                      activeDropdownId === "allUsers1" ||
                      this.isAnySubMenuActive([
                        "/all-applications",
                        "/pending-list",
                        "/screening-list",
                        "/selected-list",
                        "/onboarded-list",
                        "/onhold-list",
                        "/rejected-list",
                        "/archive-list",
                      ])
                        ? "active-item"
                        : ""
                    }`}
                  >
                    <Link
                      to="#"
                      onClick={() => this.toggleDropdown("allUsers1")}
                    >
                      <img
                        src={allapp}
                        alt="All Applications Icon"
                        className="main-image"
                      />
                      <span className="main-text">
                        {t(`Sidebar.All Applications`)}
                      </span>
                    </Link>

                    {activeDropdownId === "allUsers1" && (
                      <ul className="dropdown-list">
                        {this.checkPermissionStatus("/all-applications") && (
                          <li>
                            <Link to="/all-applications">
                              <span>{t(`Sidebar.All Applications`)}</span>
                            </Link>
                          </li>
                        )}
                        {this.checkPermissionStatus("/preassessment-list") && (
                          <li>
                            <Link to="/preassessment-list">
                              <span>
                                {t(`Sidebar.Preassessment Applications`)}
                              </span>
                            </Link>
                          </li>
                        )}
                        {this.checkPermissionStatus("/pending-list") && (
                          <li>
                            <Link to="/pending-list">
                              <span>{t(`Sidebar.New Applications`)}</span>
                            </Link>
                          </li>
                        )}
                        {this.checkPermissionStatus("/screening-list") && (
                          <li>
                            <Link to="/screening-list">
                              <span>
                                {t(`Sidebar.In Progress Applications`)}
                              </span>
                            </Link>
                          </li>
                        )}
                        {this.checkPermissionStatus("/scheduled-list") && (
                          <li>
                            <Link to="/scheduled-list">
                              <span>Scheduled Interviews</span>
                            </Link>
                          </li>
                        )}
                        {this.checkPermissionStatus("/selected-list") && (
                          <li>
                            <Link to="/selected-list">
                              <span>{t(`Sidebar.Selected Applications`)}</span>
                            </Link>
                          </li>
                        )}
                        {this.checkPermissionStatus("/onboarded-list") && (
                          <li>
                            <Link to="/onboarded-list">
                              <span>{t(`Sidebar.Onboarded Applications`)}</span>
                            </Link>
                          </li>
                        )}
                        {this.checkPermissionStatus("/onhold-list") && (
                          <li>
                            <Link to="/onhold-list">
                              <span>{t(`Sidebar.Onhold Applications`)}</span>
                            </Link>
                          </li>
                        )}
                        {this.checkPermissionStatus("/rejected-list") && (
                          <li>
                            <Link to="/rejected-list">
                              <span>{t(`Sidebar.Rejected Applications`)}</span>
                            </Link>
                          </li>
                        )}
                        {this.checkPermissionStatus("/archive-list") && (
                          <li>
                            <Link to="/archive-list">
                              <span>{t(`Sidebar.Archived Applications`)}</span>
                            </Link>
                          </li>
                        )}
                      </ul>
                    )}
                  </li>
                )}

                {this.checkPermissionStatus("/resource-pool") && (
                  <li className={this.isActive("/resource-pool")}>
                    <Link to="/resource-pool">
                      <img src={resource_pool} alt="Resource Pool" />
                      <span>{t(`Sidebar.Resource Pool`)}</span>
                    </Link>
                  </li>
                )}
                {this.checkPermissionStatus("/resume-list") && (
                  <li className={this.isActive("/resume-list")}>
                    <Link to="/resume-list">
                      <img src={bulk_import} alt="Resume List" />
                      <span>{t(`Sidebar.Resume List`)}</span>
                    </Link>
                  </li>
                )}
                {this.checkPermissionStatus("/email-list") && (
                  <li
                    className={`main-list-item ${
                      activeDropdownId === "allUsersEmail" ||
                      this.isAnySubMenuActive(["/email-list"])
                        ? "active-item"
                        : ""
                    }`}
                  >
                    <Link
                      to="#"
                      onClick={() => this.toggleDropdown("allUsersEmail")}
                    >
                      <img
                        src={locationma}
                        alt="Email icon"
                        className="main-image"
                      />
                      <span className="main-text">{t(`Sidebar.Email`)} </span>
                    </Link>

                    {activeDropdownId === "allUsersEmail" && (
                      <ul className="dropdown-list">
                        {this.checkPermissionStatus("/email-list") && (
                          <li>
                            <Link to="/email-list">
                              <span>{t(`Sidebar.Email`)}</span>
                            </Link>
                          </li>
                        )}
                      </ul>
                    )}
                  </li>
                )}

                {this.checkPermissionStatus("/import-resume") && (
                  <li className={this.isActive("/import-resume")}>
                    <Link to="/import-resume">
                      <img src={bulk_import} alt="" />
                      <span>{t(`Sidebar.Bulk Application Import`)}</span>
                    </Link>
                  </li>
                )}

                {this.checkPermissionStatus("/import-resume-user") &&
                  localStorage.getItem("subdomain") !== "mahindra" && (
                    <li className={this.isActive("/import-resume-user")}>
                      <Link to="/import-resume-user">
                        <img src={bulk_import} alt="" />
                        <span>{t("Sidebar.CV Builder")}</span>
                      </Link>
                    </li>
                  )}

                {(this.checkPermissionStatus("/partial-form") ||
                  (this.checkPermissionStatus("/region-list") &&
                    this.checkPermissionStatus("/state-list") &&
                    this.checkPermissionStatus("/city-list") &&
                    this.checkPermissionStatus("/area-list") &&
                    this.checkPermissionStatus("/store-list")) ||
                  this.checkPermissionStatus("/franchise-list") ||
                  (this.checkPermissionStatus("/department-list") &&
                    this.checkPermissionStatus("/competency-category-list") &&
                    this.checkPermissionStatus("/question-type-list") &&
                    this.checkPermissionStatus("/question-parent-list") &&
                    this.checkPermissionStatus("/question-behaviour-list") &&
                    this.checkPermissionStatus("/questions-list")) ||
                  this.checkPermissionStatus("/position-application") ||
                  this.checkPermissionStatus("/agency-application") ||
                  this.checkPermissionStatus("/employee-referral-list") ||
                  this.checkPermissionStatus("/user-list") ||
                  this.checkPermissionStatus("/role-list") ||
                  this.checkPermissionStatus("/video-sentiment") ||
                  this.checkPermissionStatus("/bot-dashboard") ||
                  this.checkPermissionStatus("/skill-list") ||
                  (this.checkPermissionStatus("/feedbacks") &&
                    this.checkPermissionStatus("/candidate-feedbacks")) ||
                  this.checkPermissionStatus("/template-list") ||
                  this.checkPermissionStatus("/cookie-consent")) && (
                  <li className="text-content">
                    <Link to="#">
                      <span>{t(`Sidebar.ACCESS`)}</span>
                    </Link>
                  </li>
                )}

                {this.checkPermissionStatus("/partial-form") && (
                  <li className={this.isActive("/partial-form")}>
                    <Link to="/partial-form">
                      <img src={particial_iocn} alt="Partial Form Icon" />
                      <span>{t(`Sidebar.Partial Form`)}</span>
                    </Link>
                  </li>
                )}

                {this.checkPermissionStatus("/region-list") &&
                  this.checkPermissionStatus("/state-list") &&
                  this.checkPermissionStatus("/city-list") &&
                  this.checkPermissionStatus("/area-list") &&
                  this.checkPermissionStatus("/store-list") && (
                    <li
                      className={`main-list-item ${
                        activeDropdownId === "allUsers2" ||
                        this.isAnySubMenuActive([
                          "/region-list",
                          "/state-list",
                          "/city-list",
                          "/area-list",
                          "/store-list",
                        ])
                          ? "active-item"
                          : ""
                      }`}
                    >
                      <Link
                        to="#"
                        onClick={() => this.toggleDropdown("allUsers2")}
                      >
                        <img
                          src={locationma}
                          alt="Location Manager Icon"
                          className="main-image"
                        />
                        <span className="main-text">
                          {t(`Sidebar.Location Manager`)}{" "}
                        </span>
                      </Link>

                      {activeDropdownId === "allUsers2" && (
                        <ul className="dropdown-list">
                          {this.checkPermissionStatus("/region-list") && (
                            <li>
                              <Link to="/region-list">
                                <span>{t(`Sidebar.Region`)}</span>
                              </Link>
                            </li>
                          )}
                          {this.checkPermissionStatus("/state-list") && (
                            <li>
                              <Link to="/state-list">
                                <span>{t(`Sidebar.State`)}</span>
                              </Link>
                            </li>
                          )}
                          {this.checkPermissionStatus("/city-list") && (
                            <li>
                              <Link to="/city-list">
                                <span>{t(`Sidebar.City`)}</span>
                              </Link>
                            </li>
                          )}
                          {this.checkPermissionStatus("/area-list") &&
                            parseInt(localStorage.getItem("company_type")) ===
                              0 && (
                              <li>
                                <Link to="/area-list">
                                  <span>{t(`Sidebar.Area`)}</span>
                                </Link>
                              </li>
                            )}
                          {this.checkPermissionStatus("/store-list") &&
                            parseInt(localStorage.getItem("company_type")) ===
                              1 && (
                              <li>
                                <Link to="/store-list">
                                  <span>{t(`Sidebar.Store`)}</span>
                                </Link>
                              </li>
                            )}
                        </ul>
                      )}
                    </li>
                  )}
                {this.checkPermissionStatus("/franchise-list") && (
                  <li className={this.isActive("/franchise-list")}>
                    <Link to="/franchise-list">
                      <img src={frencise} alt="Franchise Icon" />
                      <span>{t(`Sidebar.Franchise`)}</span>
                    </Link>
                  </li>
                )}

                {/* Shailu:Questions */}
                {this.checkPermissionStatus("/department-list") &&
                  this.checkPermissionStatus("/competency-category-list") &&
                  this.checkPermissionStatus("/question-type-list") &&
                  this.checkPermissionStatus("/question-parent-list") &&
                  this.checkPermissionStatus("/question-behaviour-list") &&
                  this.checkPermissionStatus("/questions-list") && (
                    <li
                      className={`main-list-item ${
                        activeDropdownId === "mcqManager" ||
                        this.isAnySubMenuActive([
                          "/mcq-dashboard",
                          "/competency-category-list",
                          "/question-parent-list",
                          "/questions-list",
                        ])
                          ? "active-item"
                          : ""
                      }`}
                    >
                      <Link
                        to="#"
                        onClick={() => this.toggleDropdown("mcqManager")}
                      >
                        <img
                          src={mcq_icon}
                          alt="MCQ Manager Icon"
                          className="main-image"
                        />
                        <span className="main-text">
                          {t(`Sidebar.MCQ Manager`)}{" "}
                        </span>
                      </Link>

                      {activeDropdownId === "mcqManager" && (
                        <ul className="dropdown-list">
                          {this.checkPermissionStatus("/mcq-dashboard") && (
                            <li>
                              <Link to="/mcq-dashboard">
                                {/* <i className="bx bx-task" /> */}
                                <span>MCQ Dashboard</span>
                              </Link>
                            </li>
                          )}

                          {this.checkPermissionStatus(
                            "/competency-category-list"
                          ) && (
                            <li>
                              <Link to="/competency-category-list">
                                {/* <i className="bx bx-task" /> */}
                                <span>{t(`Sidebar.Competency Category`)}</span>
                              </Link>
                            </li>
                          )}

                          {this.checkPermissionStatus(
                            "/question-parent-list"
                          ) && (
                            <li>
                              <Link to="/question-parent-list">
                                {/* <i className="bx bx-task" /> */}
                                <span>
                                  {t(`Sidebar.Questions Parent Type`)}
                                </span>
                              </Link>
                            </li>
                          )}

                          {this.checkPermissionStatus("/questions-list") && (
                            <li>
                              <Link to="/questions-list">
                                {/* <i className="bx bx-task" /> */}
                                <span>{t(`Sidebar.Questions`)}</span>
                              </Link>
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  )}
                {(this.checkPermissionStatus("/position-application") ||
                  this.checkPermissionStatus("/admin-logs") ||
                  this.checkPermissionStatus("/user-activity-logs")) && (
                  <li
                    className={`main-list-item ${
                      activeDropdownId === "allUsers3" ||
                      this.isAnySubMenuActive(["/position-application", "/admin-logs", "/user-activity-logs"])
                        ? "active-item"
                        : ""
                    }`}
                  >
                    <Link
                      to="#"
                      onClick={() => this.toggleDropdown("allUsers3")}
                    >
                      <img
                        src={allreports}
                        alt="All Reports Icon"
                        className="main-image"
                      />
                      <span className="main-text">
                        {t(`Sidebar.All Reports`)}{" "}
                      </span>
                    </Link>

                    {activeDropdownId === "allUsers3" && (
                      <ul className="dropdown-list">
                        {this.checkPermissionStatus("/position-application") && (
                          <li>
                            <Link to="/position-application">
                              <span>
                                {t(`Sidebar.Positions vs Applications`)}
                              </span>
                            </Link>
                          </li>
                        )}
                        {this.checkPermissionStatus("/admin-logs") && (
                          <li>
                            <Link to="/admin-logs">
                              <span>{t(`Sidebar.All Admin Logs`)}</span>
                            </Link>
                          </li>
                        )}
                        {this.checkPermissionStatus("/user-activity-logs") && (
                          <li>
                            <Link to="/user-activity-logs">
                              <span>{t(`Sidebar.User Activity Logs`)}</span>
                            </Link>
                          </li>
                        )}
                      </ul>
                    )}
                  </li>
                )}

                {this.checkPermissionStatus("/agency-application") && (
                  <li
                    className={`main-list-item ${
                      activeDropdownId === "allUsers3" ||
                      this.isAnySubMenuActive(["/agency-application"])
                        ? "active-item"
                        : ""
                    }`}
                  >
                    {activeDropdownId === "allUsers3" && (
                      <ul className="dropdown-list">
                        {this.checkPermissionStatus("/agency-application") && (
                          <li>
                            <Link to="/agency-application">
                              <span>{t(`Sidebar.Agency_Applications`)}</span>
                            </Link>
                          </li>
                        )}
                      </ul>
                    )}
                  </li>
                )}

                {this.checkPermissionStatus("/employee-referral-list") && (
                  <li
                    className={`main-list-item ${
                      activeDropdownId === "referralManagement" ||
                      this.isAnySubMenuActive(["/employee-referral-list"])
                        ? "active-item"
                        : ""
                    }`}
                  >
                    <Link
                      to="#"
                      onClick={() => this.toggleDropdown("referralManagement")}
                    >
                      <img
                        src={refrelmanagemt}
                        alt="Referral Management Icon"
                        className="main-image"
                      />
                      <span className="main-text">
                        {t(`Sidebar.Referral Management`)}
                      </span>
                    </Link>

                    {activeDropdownId === "referralManagement" && (
                      <ul className="dropdown-list">
                        {this.checkPermissionStatus(
                          "/employee-referral-list"
                        ) && (
                          <li>
                            <Link to="/employee-referral-list">
                              {/* <img src={locationma} alt="" className="main-image" /> */}
                              <span>{t(`Sidebar.Employee Referral`)}</span>
                            </Link>
                          </li>
                        )}
                      </ul>
                    )}
                  </li>
                )}

                {(this.checkPermissionStatus("/user-list") ||
                  this.checkPermissionStatus("/role-list")) && (
                    <li
                      className={`main-list-item ${
                        activeDropdownId === "allUsers4" ||
                        this.isAnySubMenuActive(["/user-list", "/role-list"])
                          ? "active-item"
                          : ""
                      }`}
                    >
                      <Link
                        to="#"
                        onClick={() => this.toggleDropdown("allUsers4")}
                      >
                        <img
                          src={alluser}
                          alt="All Users Icon"
                          className="main-image"
                        />
                        <span className="main-text">
                          {t(`Sidebar.All Users`)}{" "}
                        </span>
                      </Link>

                      {activeDropdownId === "allUsers4" && (
                        <ul className="dropdown-list">
                          {this.checkPermissionStatus("/user-list") && (
                            <li>
                              <Link to="/user-list">
                                <span>{t(`Sidebar.User List`)}</span>
                              </Link>
                            </li>
                          )}
                          {this.checkPermissionStatus("/role-list") && (
                            <li>
                              <Link to="/role-list">
                                <span>{t(`Sidebar.User Roles`)}</span>
                              </Link>
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  )}

                {this.checkPermissionStatus("/video-sentiment") && (
                  <li className={this.isActive("/video-sentiment")}>
                    <Link to="/sentiment">
                      <img
                        src={sentiment_icon}
                        alt="Video Sentiment Analysis Icon"
                        className="main-image"
                      />
                      <span className="main-text">
                        {t(`Sidebar.Video Sentiment Analysis`)}
                      </span>
                    </Link>
                  </li>
                )}

                {this.checkPermissionStatus("/bot-dashboard") && (
                  <li className={this.isActive("/bot-dashboard")}>
                    <Link to="/bot-dashboard">
                      <img
                        src={neuro_bot}
                        alt="Neurorecruit Bot Icon"
                        className="main-image"
                      />
                      <span className="main-text">
                        {t(`Sidebar.Neurorecruit Bot`)}
                      </span>
                    </Link>
                  </li>
                )}

                {this.checkPermissionStatus("/skill-list") && (
                  <li className={this.isActive("/skill-list")}>
                    <Link to="/skill-list">
                      <img src={skill_set} alt="Skill List Icon" />
                      <span>{t(`Sidebar.Skill List`)}</span>
                    </Link>
                  </li>
                )}

                {this.checkPermissionStatus("/feedbacks") &&
                  this.checkPermissionStatus("/candidate-feedbacks") && (
                    <li
                      className={`main-list-item ${
                        activeDropdownId === "allUsers7" ||
                        this.isAnySubMenuActive([
                          "/feedbacks",
                          "/candidate-feedbacks",
                        ])
                          ? "active-item"
                          : ""
                      }`}
                    >
                      <Link
                        to="#"
                        onClick={() => this.toggleDropdown("allUsers7")}
                      >
                        <img src={feedback_icon} alt="Feedbacks Icon" />
                        <span className="main-text">
                          {t(`Sidebar.Feedbacks`)}{" "}
                        </span>
                      </Link>

                      {activeDropdownId === "allUsers7" && (
                        <ul className="dropdown-list">
                          {this.checkPermissionStatus("/feedbacks") && (
                            <li className={this.isActive("/feedbacks")}>
                              <Link to="/feedbacks">
                                {/* <img src={feedback_icon} alt="feedbacks Icon" /> */}
                                <span>{t(`Sidebar.Feedbacks`)}</span>
                              </Link>
                            </li>
                          )}
                          {this.checkPermissionStatus(
                            "/candidate-feedback"
                          ) && (
                            <li
                              className={this.isActive("/candidate-feedback")}
                            >
                              <Link to="/candidate-feedbacks">
                                {/* <img
                                 src={feedback_icon}
                                 alt="Candidate Feedbacks Icon"
                               /> */}
                                <span>{t(`Sidebar.Candidate Feedbacks`)}</span>
                              </Link>
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  )}

                {this.checkPermissionStatus("/template-list") && (
                  <li
                    className={`main-list-item ${
                      activeDropdownId === "activetemplate" ||
                      this.isAnySubMenuActive([
                        "/template-list",
                        "/template-list",
                      ])
                        ? "active-item"
                        : ""
                    }`}
                  >
                    <Link
                      to="#"
                      onClick={() => this.toggleDropdown("activetemplate")}
                    >
                      <img src={templatelist} alt="" />
                      <span className="main-text">
                        {t(`Sidebar.Template List`)}{" "}
                      </span>
                    </Link>

                    {activeDropdownId === "activetemplate" && (
                      <ul className="dropdown-list">
                        {this.checkPermissionStatus("/template-list") && (
                          <li className={this.isActive("/template-list")}>
                            <Link to="/template-list">
                              {/* <img src={templatelist} alt="" /> */}
                              <span>{t(`Sidebar.Template List`)}</span>
                            </Link>
                          </li>
                        )}
                      </ul>
                    )}
                  </li>
                )}

                {this.checkPermissionStatus("/cookie-consent") && (
                  <ul>
                    <li className={this.isActive("/cookie-consent-dashboard")}>
                      <Link to="/cookie-consent-dashboard">
                        <img src={dashboard} alt="Dashboard Icon" />
                        <span>{t(`Dashboard.Dashboard`)}</span>
                      </Link>
                    </li>

                    <li className={this.isActive("/cookie-list")}>
                      <Link to="/cookie-list">
                        <img
                          src={cookies_cons}
                          alt="Cookies Consent List Icon"
                        />
                        <span>{t(`Sidebar.Cookies Consent List`)}</span>
                      </Link>
                    </li>

                    <li className={this.isActive("/consent-list")}>
                      <Link to="/consent-list">
                        <img src={pii_cons} alt="PII Consent List Icon" />
                        <span>{t(`Sidebar.PII Consent List`)}</span>
                      </Link>
                    </li>

                    <li className={this.isActive("/account-deletion-list")}>
                      <Link to="/account-deletion-list">
                        <img
                          src={account_delete}
                          alt="Account Deletion Requests Icon"
                        />
                        <span>{t(`Sidebar.Account Deletion Requests`)}</span>
                      </Link>
                    </li>

                  </ul>
                )}
              </ul>
              {this.checkPermissionStatus("/settings") && (
                <ul className="settings">
                  <li className="mm-active">
                    <Link to="/settings">
                      <img src={settings} alt="All Settings Icon" />
                      <span>{t(`Sidebar.All Settings`)}</span>
                    </Link>
                  </li>
                </ul>
              )}
            </div>
          </div>
          <div className="sidebar-background"></div>
        </div>
      </React.Fragment>
    );
  }
}

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStateToProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
